module.exports = __webpack_public_path__ + "static/img/11.07f1e50.png";


//////////////////
// WEBPACK FOOTER
// ./img/yj/11.png
// module id = 6xeY
// module chunks = 1